module.exports = __webpack_public_path__ + "img/main-first_section.6cb467cf.png";